import { graphApi } from "@services/api/graphApi";
import { User } from "@microsoft/microsoft-graph-types";

export async function getUser(): Promise<User> {
	try {
		const response = await graphApi.get<User>(
			"https://graph.microsoft.com/v1.0/me",
		);
		return response.data;
	} catch (error) {
		console.error("Error fetching user:", error);
		throw error;
	}
}

export async function revokeAllUserSessions() {
	try {
		const response = await graphApi.post("/me/revokeSignInSessions");
		return response.data;
	} catch (error) {
		console.error("Error revoking user sessions:", error);
		throw error;
	}
}

export async function changePassword(
	currentPassword: string,
	newPassword: string,
) {
	await graphApi.post("/me/changePassword", { currentPassword, newPassword });
}
